export default class Games {

    constructor() {
    }

    restart() {

    }

    rules() {

    }

    points(conditions) {

        if (conditions.founded && !conditions.know) {
            return 8;
        }

        if (conditions.founded && conditions.know) {
            return 6;
        }


        return 0;
    };
}
